// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__180kt","head":"ProcedureTableInfo_head__1V-vi"};